import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Drawer, Toolbar, AppBar, Typography } from '@mui/material';
import logoIcintracom from 'src/img/intracom.png';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Menu from 'src/components/OptionMenu';
import LogoutButton from 'src/components/LogoutButton';
import UserService from 'src/services/UserService';

const drawerWidth = 240;

const camelize = (text = "") =>
    text.replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""))
        .replace(/^./, (c) => c.toUpperCase());

const Home = () => {
    const username = UserService.gerUser() ?? "Usuario";

    return (
        <Box sx={{ display: "flex" }}>
            <Drawer
                variant="permanent"
                anchor="left"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {
                        width: drawerWidth,
                        boxSizing: "border-box",
                        backgroundColor: "#0A2342",
                        color: "white",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "20px 0",
                        borderBottom: "1px solid rgba(255,255,255,0.2)",
                    }}
                >
                    <img src={logoIcintracom} alt="logo" style={{ width: "150px" }} />
                </Box>
                <Menu />
            </Drawer>

            <AppBar
                position="fixed"
                sx={{
                    width: `calc(100% - ${drawerWidth}px)`,
                    ml: `${drawerWidth}px`,
                    height: '75px',
                    backgroundColor: "#0A2342",
                    color: "#ffffff",
                    boxShadow: "none",
                    borderBottom: "1px solid #ddd",
                }}
            >
                <Toolbar sx={{ justifyContent: "flex-end", gap: 3 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <AccountCircleIcon />
                        <Typography>{camelize(username)}</Typography>
                    </Box>
                    <Typography>|</Typography>
                    <LogoutButton />
                </Toolbar>
            </AppBar>

            <Box component="main" sx={{ flexGrow: 1, p: 3, marginTop: "64px" }}>
                <Outlet />
            </Box>
        </Box>
    );
};

export default Home;
